var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "p-4 flex flex-col gap-2 rounded-2xl bg-slate-200" },
      [
        _c(
          "div",
          { staticClass: "flex items-center justify-between" },
          [
            _c("BlTextSubtitle2", {
              staticClass: "text-slate-800",
              attrs: { text: _vm.sectionName }
            }),
            _vm._v(" "),
            _c("BlInputButton", {
              attrs: { icon: "edit", type: "plain", title: "Edit section" },
              on: {
                clicked: function($event) {
                  _vm.editOpened = true
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col gap-1" },
          [
            _c("BlTextBody2", { attrs: { text: _vm.guardianNameInput.label } }),
            _vm._v(" "),
            _c("BlTextBody2", {
              staticClass: "text-slate-1000",
              attrs: { text: _vm.prospectInformation.guardian_name }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col gap-1" },
          [
            _c("BlTextBody2", {
              attrs: { text: _vm.relationshipTypeInput.label }
            }),
            _vm._v(" "),
            _c("BlTextBody2", {
              staticClass: "text-slate-1000 capitalize",
              attrs: {
                text: _vm.prospectInformation.guardian_relationship_type || "-"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col gap-1" },
          [
            _c("BlTextBody2", {
              attrs: { text: _vm.guardianPhoneNumberInput.label }
            }),
            _vm._v(" "),
            _c("BlTextBody2", {
              staticClass: "text-slate-1000",
              attrs: {
                text: _vm.prospectInformation.guardian_phone_number || "-"
              }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "fixed w-screen right-0 flex justify-end transition-all duration-500",
        style: {
          top: _vm.editOpened ? "calc(4.5rem + 5rem)" : "calc(100vh)",
          height: "calc(100vh - 4.5rem - 5rem)",
          zIndex: 53
        },
        attrs: { id: "edit-client-information-panel" }
      },
      [
        _c("div", {
          staticClass: "h-full w-screen absolute left-0 top-0 -z-10",
          on: {
            click: function($event) {
              _vm.editOpened = false
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "h-full w-120 flex-shrink-0 flex flex-col relative z-0"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "relative h-full flex flex-col justify-between bg-pure-white overflow-y-auto"
              },
              [
                _c("div", { staticClass: "px-6 flex flex-col" }, [
                  _c(
                    "div",
                    {
                      staticClass: "sticky top-0 z-10 py-3 bg-pure-white mb-0"
                    },
                    [
                      _c("BlTextSubtitle2", {
                        staticClass: "text-slate-800",
                        attrs: { text: "Edit " + _vm.sectionName }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-3" },
                    [
                      _c("BlInputText", {
                        attrs: { input: _vm.guardianNameInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlSelectBox", {
                        attrs: {
                          label: _vm.relationshipTypeInput.label,
                          placeholder: "Select relationship",
                          options: _vm.relationshipTypeOptions
                        },
                        on: {
                          change: function($event) {
                            _vm.relationshipTypeInput.model = $event
                          }
                        },
                        model: {
                          value: _vm.relationshipTypeInput.model,
                          callback: function($$v) {
                            _vm.$set(_vm.relationshipTypeInput, "model", $$v)
                          },
                          expression: "relationshipTypeInput.model"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputText", {
                        attrs: { input: _vm.guardianPhoneNumberInput },
                        on: { changed: _vm.inputHandler }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "h-18 px-6 pt-4 sticky bottom-0 flex-shrink-0 bg-pure-white grid grid-cols-2 gap-4"
                  },
                  [
                    _c("BlInputButton", {
                      attrs: { label: "Close", type: "plain" },
                      on: {
                        clicked: function($event) {
                          _vm.editOpened = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("BlInputButton", {
                      attrs: { label: "Update", loading: _vm.submitLoading },
                      on: { clicked: _vm.onUpdate }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddf54dc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddf54dc8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/prospectPanel/clientInformation/OtherGuardianSection.vue
// module id = null
// module chunks = 